import { render, staticRenderFns } from "./zonglan.vue?vue&type=template&id=0836a653&scoped=true&"
import script from "./zonglan.vue?vue&type=script&lang=js&"
export * from "./zonglan.vue?vue&type=script&lang=js&"
import style0 from "./zonglan.vue?vue&type=style&index=0&id=0836a653&scoped=true&lang=css&"
import style1 from "./zonglan.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836a653",
  null
  
)

export default component.exports